import {all, call, spawn} from 'redux-saga/effects'
import {watchWithSpeedBump} from 'redux/speedBump/speedBump.duck'
import {handleError} from 'helpers/common'

const sagas = [
  watchWithSpeedBump,
]

const rootSaga = function* () {
  yield all(sagas.map(saga =>
    spawn(function* () {
      while (true) {
        try {
          yield call(saga)
          break
        } catch (err) {
          handleError('REDUX / Redux Saga', err)
        }
      }
    }))
  )
}
export default rootSaga
